import React,{createContext, useReducer,useEffect,useState} from 'react'
import  Reducer  from './newfile'



const storage = localStorage.getItem('cartitem')?JSON.parse(localStorage.getItem('cartitem')):[]
export  const conitem = createContext()



const initaistate = {
title :storage
}


  







const Contextitem = ({children}) => {
  const [state , dispatch] = useReducer(Reducer, initaistate)
  const [basketiconvalue , setbasketiconvalue] = useState(state.title.length)


  



  
    const addwishlist=(payload)=>{
console.log(payload)
    }
  const addproduct = (payload)=>{
    dispatch({type:'Add',payload})
    alert('item add to Cart')
    setbasketiconvalue(pevCount=>pevCount+1)
  }
  
  const addition = (payload)=>{
  
    dispatch({type:'increment',payload})
    return state.title
    
  }
  const reduction =(payload)=>{
    dispatch({type:'decrement',payload})
    
    return state.title
    
  }
  const del = (payload)=>{
  
    dispatch({type:'del',payload})
    setbasketiconvalue(state.title.length)
    return state.title
    
   
    
  
  }
 
  const clearBasket = ()=>{
    dispatch({type:'remove'})
    setbasketiconvalue(state.title.length)
    return state.title
   
  
  }
  
 
   
const getitem = ()=>{  
  return state.title
 }

 


  let contextstate = {
  
    addproduct,
    dispatch,
    addition,
    reduction,
    del,
    clearBasket,
    getitem,
    basketiconvalue ,
    addwishlist,
    ...state
    
  }

 
  return (
    <div>
    <conitem.Provider value={contextstate} >
       {children}
    </conitem.Provider>

    </div>
  )
}

export default Contextitem